import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
import { Activity, OrganisationActivityCategory } from 'app/shared/components/activity/activity-details.model';

/**
 * Service for activity services.
 */
@Injectable()
export class ActivityService {
  constructor(private requestService: ObservableRequestService) { }

  fetchActivityDetails(id: number): Observable<any> {
    return this.requestService.getRequest(
      `${ConstantsService.LIST_ORG_ACTIVITY_INFORMATION}/${id}`);
  }

  getActivities(searchString: string): Observable<any> {
    return this.requestService.getRequest(
      `${ConstantsService.GET_ACTIVITIES}/${searchString}`);
  }

  addActivity(activity: Activity): Observable<any> {
    return this.requestService.postRequest(
      ConstantsService.ADD_ACTIVITY,
      JSON.stringify(activity),
      this.requestService.getJSONContentType());
  }

  deleteActivity(activity: Activity): Observable<any> {
    return this.requestService.deleteRequest(
      ConstantsService.LIST_ORG_ACTIVITY_INFORMATION,
      JSON.stringify(activity),
      this.requestService.getJSONContentType());
  }

  updateActivityCategoryDetails(activityCategoryDetails: OrganisationActivityCategory): Observable<any> {
    return this.requestService.putRequest(
      ConstantsService.UPDATE_ACTIVITY_CATEGORY,
      JSON.stringify(activityCategoryDetails),
      this.requestService.getJSONContentType());
  }

  updateActivitySummary(updateCategorySummary: any): Observable<any> {
    return this.requestService.putRequest(
      ConstantsService.UPDATE_ACTIVITY_CATEGORY_SUMMARY,
      this.requestService.serialize(updateCategorySummary),
      this.requestService.getFormEncodedContentType());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity/activity.service.ts